import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import AssociatePage from '../HomeAssociate/index';
import SupplierPage from '../HomeSupplier/index';
import ProductsPage from '../HomeProduct/index';
import { IHomePage } from 'Module/Home/Interface';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component={'div'}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function HomeTabPanelPage(props: IHomePage) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          indicatorColor="secondary"
          textColor="secondary"
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Associados" {...a11yProps(0)} />
          <Tab label="Fornecedores" {...a11yProps(1)} />
          <Tab label="Produtos Faturados" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <AssociatePage {...props} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <SupplierPage {...props} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <ProductsPage {...props} />
      </CustomTabPanel>
    </Box>
  );
}